import { QueryClient } from '@tanstack/react-query'

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000, // 5 minutes
      retry: 1,
    },
  },
})

// API request helper
export async function apiRequest(endpoint, options = {}) {
  const url = `https://node-js-server-web3brokerai.replit.app/api${endpoint.startsWith('/') ? endpoint : `/${endpoint}`}`

  const config = {
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
    ...options,
  }

  const response = await fetch(url, config)

  if (!response.ok) {
    const error = await response.json().catch(() => ({
      message: `HTTP ${response.status}: ${response.statusText}`
    }))
    throw new Error(error.message || 'Request failed')
  }

  return response.json()
}
